// startTimerAnimation.js
var StartTimerAnimation = pc.createScript('startTimerAnimation');

StartTimerAnimation.attributes.add("extraTimeButton", { type: "entity" });
StartTimerAnimation.attributes.add("timerText", { type: "entity" });
StartTimerAnimation.attributes.add("homeButton", { type: "entity" });
StartTimerAnimation.attributes.add('Shine', { type: 'entity' });
StartTimerAnimation.attributes.add("shakeAnimationButton", { type: "entity" });
StartTimerAnimation.attributes.add("shakeAnimationTutorialImage", { type: "entity" });
StartTimerAnimation.attributes.add("jokerAnimationButton", { type: "entity" });
StartTimerAnimation.attributes.add("miniGameJokerTutorialImage", { type: "entity" });

var extraTimeBtnShown;
var startGameSoundStatus = true;
var shineAnimation;

StartTimerAnimation.prototype.initialize = function () {

    StartTimerAnimation.instance = this;
    this.entity.enabled = false;
    this.timerAnim = null;
    this.extraTimeButtonAnim = null;

    this.extraTimeButton.enabled = false;
    // GAADSManager.instance.readyADS(function(status){
    //     if (status) {
    //         this.extraTimeButton.enabled = true;
    //     }
    // });
    if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
        gdsdk
            .preloadAd('rewarded')
            .then(response => {
                this.extraTimeButton.enabled = true;
            })
            .catch(error => {

            });
    }

    this.extraTimeButton.button.on('click', function (event) {

        SoundManager.instance.stopSound('StartSound');
        extraTimeBtnShown = false;
        this.entity.enabled = false;
        this.extraTimeButton.enabled = false;
        this.timerAnim.stop();
        this.extraTimeButtonAnim.stop();

        //GAADSManager.instance.showRewarded(adsType.FirstExtraTime);
        rewardedType = adsType.FirstExtraTime;
        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk.showAd('rewarded');
        }



        // SoundManager.instance.stopSound('StartSound');
        // extraTimeBtnShown = false;
        // ADSManager.instance.matchStartAds = true;
        // this.entity.enabled = false;
        // this.extraTimeButton.enabled = false;

        // this.timerAnim.stop();
        // this.extraTimeButtonAnim.stop();

        // SoundManager.instance.playSound('LevelStart');
        // if (GameAnalyticsSdk.instance.gaStatus) { GameAnalytics("addDesignEvent", "LevelStartExtraTimeButton:Click", 1); }
        // ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial);
    }, this);

    this.app.on("startTimerEffect", this.startEffect, this);
    this.entity.on("destroy", this.OnDestroy, this);
};

StartTimerAnimation.prototype.getExtraTime = function () {

    SoundManager.instance.playSound('LevelStart');
    GameManager.instance.ExtraTime();
    this.matchStartAds = false;
};

StartTimerAnimation.prototype.startEffect = function () {

    var timerCounterText = 3;

    if (PlayerManager.instance.levelData.levelName != "Donut Shop") {

        extraTimeBtnShown = false;
        TimeBar.instance.setProgress(0.12);

        this.homeButton.enabled = false;
        GameManager.instance.PauseGame();

        this.entity.enabled = true;
        this.timerText.enabled = true;
        SoundManager.instance.playSound('StartSound');
        shineAnimation = this.Shine.tween(this.Shine.getLocalPosition()).to({ x: 269.172, y: -13.637, z: 0 }, 1.5, pc.Linear).on('complete', function () { StartTimerAnimation.instance.Shine.setLocalPosition(new pc.Vec3(-271.456, -13.637, 0)); }).loop(true);
        shineAnimation.start();

        this.timerAnim = this.timerText
            .tween(this.timerText.getLocalScale())
            .to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut)
            .on("complete", function () {

                timerCounterText--;
                if (timerCounterText >= 0) {
                    StartTimerAnimation.instance.timerText.element.text = timerCounterText;
                }
                if (timerCounterText >= 0) {
                    this.extraTimeButtonAnim.start();
                    this.timerAnim.start();
                }
                else {
                    this.finishTimerAnimation();
                }
            }, this)
            .yoyo(true)
            .repeat(2);

        this.extraTimeButtonAnim = this.extraTimeButton.tween(this.extraTimeButton.getLocalScale()).to(new pc.Vec3(0.8, 0.8, 0.8), 0.8, pc.QuadraticInOut).yoyo(true).repeat(2);

        this.extraTimeButtonAnim.start();
        this.timerAnim.start();

        //this.timerTextAnimation = this.timerText.tween(this.timerText.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut).on('complete', function () { StartTimerAnimation.instance.timerText.element.text = "2"; StartTimerAnimation.instance.timerAnimation2(); }).yoyo(true).repeat(2).start();
        setTimeout(function () { StartTimerAnimation.instance.extraTimeButton.tween(StartTimerAnimation.instance.extraTimeButton.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut).yoyo(true).repeat(2).start(); }, 5, this);
    }


};
StartTimerAnimation.prototype.playStartSound = function () {
    SoundManager.instance.playSound('LevelStart');
};

StartTimerAnimation.prototype.timerAnimation2 = function () {
    this.timerTextAnimation2 = this.timerText.tween(this.timerText.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut).on('complete', function () { StartTimerAnimation.instance.timerText.element.text = "1"; StartTimerAnimation.instance.timerAnimation3(); }).yoyo(true).repeat(2).start();
    this.extraTimeButton.tween(this.extraTimeButton.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut).yoyo(true).repeat(2).start();
};
StartTimerAnimation.prototype.timerAnimation3 = function () {
    this.timerTextAnimation3 = this.timerText.tween(this.timerText.getLocalScale()).to(new pc.Vec3(1, 1, 1), 1, pc.QuadraticInOut).on('complete', function () { StartTimerAnimation.instance.timerText.element.text = "0"; StartTimerAnimation.instance.timerAnimation4(); }).yoyo(true).repeat(2).start();
    this.extraTimeButton.tween(this.extraTimeButton.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut).yoyo(true).repeat(2).start();
};

StartTimerAnimation.prototype.finishTimerAnimation = function () {

    // if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {

    //     StartTimerAnimation.instance.jokerAnimationButton.enabled = true;
    //                     StartTimerAnimation.instance.miniGameJokerTutorialImage.enabled = false;
    //         GameManager.instance.ResumeGame();

    // }
    // else {
    //     StartTimerAnimation.instance.jokerAnimationButton.enabled = false;
    //         StartTimerAnimation.instance.shakeAnimationTutorialImage.enabled = false;

    //         GameManager.instance.ResumeGame();

    // }


    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {

        StartTimerAnimation.instance.jokerAnimationButton.enabled = true;

        if (PlayerManager.instance.userData.jokerTutorial == undefined || PlayerManager.instance.userData.jokerTutorial == "0" || PlayerManager.instance.userData.jokerTutorial == null) {
            //StartTimerAnimation.instance.miniGameJokerTutorialImage.enabled = true;
        }
        else {
            //StartTimerAnimation.instance.miniGameJokerTutorialImage.enabled = false;
            GameManager.instance.ResumeGame();
        }
    }
    else {
        StartTimerAnimation.instance.jokerAnimationButton.enabled = false;
        if (PlayerManager.instance.userData.shakeTutorial == undefined || PlayerManager.instance.userData.shakeTutorial == "0" || PlayerManager.instance.userData.shakeTutorial == null || PlayerManager.instance.userData.shakeTutorial == false) {
            GameManager.instance.ResumeGame();
            //StartTimerAnimation.instance.shakeAnimationTutorialImage.enabled = true;
        }
        else {
            //StartTimerAnimation.instance.shakeAnimationTutorialImage.enabled = false;

            GameManager.instance.ResumeGame();
        }
    }

    SoundManager.instance.stopSound('StartSound');
    SoundManager.instance.playSound('LevelStart');
    StartTimerAnimation.instance.entity.enabled = false;
    StartTimerAnimation.instance.timerText.enabled = false;
    StartTimerAnimation.instance.timerText.element.text = "3";
    StartTimerAnimation.instance.homeButton.enabled = true;
    shineAnimation.stop();

    StartTimerAnimation.instance.shakeAnimationButton.enabled = true;

};


StartTimerAnimation.prototype.OnDestroy = function () {
    this.app.off("startTimerEffect", this.startEffect, this);
    this.entity.off("destroy", this.OnDestroy, this);
};


